export const defaultConfig = {
  borderColor: 'rgba(255, 255, 255, 0)',
  gradient: {
    0.25: 'rgba(0, 0, 0, 0)',
    0.5: 'rgba(0, 255, 0, 1)',
    0.75: 'rgba(255, 255, 0, 1)',
    1: 'rgba(255, 0, 0, 1)'
  },
  max: 100,
  shape: 'square',
  size: 10,
  visible: true,
  wInterval: 0.000081
};
